import React, { FC } from "react";
import { CloseIcon, Input, Modal, SearchIcon } from "@pd/pd-ui-kit";
import { useTranslation } from "react-i18next";

import SelectUserForm from "~/components/Forms/SelectUserForm";
import { useSetLocationData } from "~/hooks/locationData";

import s from "./styles.less";

interface Props {
  openModal: string;
  value?: string;
}

const UserSearchFilter: FC<Props> = ({ openModal, value = "" }) => {
  const { t } = useTranslation();
  const setData = useSetLocationData();

  const handleCloseModal = () => {
    setData("openModal", "");
  };

  const openSelectUserModal = () => {
    setData("openModal", "selectUser");
  };

  const resetUser = (e: React.MouseEvent) => {
    e.stopPropagation();
    setData("UserId", "", "searchText", "");
  };

  return (
    <div className={s.inputContainer}>
      <div className={s.input} onClick={openSelectUserModal}>
        <Input
          value={value}
          placeholder={t("ui.user_search")}
          readOnly
          suffix={
            value ? (
              <CloseIcon size={12} className={s.reset} onClick={resetUser} />
            ) : (
              <SearchIcon size={16} />
            )
          }
        />
      </div>

      <Modal
        open={openModal === "selectUser"}
        title={t("ui.user_search")}
        onCancel={handleCloseModal}
        closable
        centered
        destroyOnHidden
        footer={null}
      >
        <SelectUserForm />
      </Modal>
    </div>
  );
};

export default UserSearchFilter;
